export class Traveler {
  uuid: string;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  profilePicture: string;
  birthdate: string;
  phoneNumber: string;
  active: string;
  refreshToken: string;
  gmail: string;
  facebook: string;
  verified: string;
  cityId: string;
  roleId: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;

  constructor() {
    this.uuid = '';
    this.email = '';
    this.password = '';
    this.firstName = '';
    this.lastName = '';
    this.profilePicture = '';
    this.birthdate = '';
    this.phoneNumber = '';
    this.active = '';
    this.refreshToken = '';
    this.gmail = '';
    this.facebook = '';
    this.verified = '';
    this.cityId = '';
    this.roleId = '';
    this.createdAt = '';
    this.updatedAt = '';
    this.deletedAt = '';
  }
}
